import { saveAs } from 'file-saver';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { ActivityNimReadDTO } from '../../api/dto';
import { useApplicationContext } from '../../components/application/ApplicationContextProvider';
import { COMMON_DOCUMENT_BUTTONS, DocumentButtonsStack } from '../../components/documents/DocumentButtonsStack';
import { generateGuidedVisitDocx } from './GuidedVistisDocx';

interface PrintGuidedVisitsButtonProps {
    formIsDirty: boolean;
    activity: ActivityNimReadDTO;
}

export const PrintGuidedVisitsButton: React.FC<PrintGuidedVisitsButtonProps> = ({ formIsDirty, activity }) => {
    const intl = useIntl();
    const [isGenerating, setIsGenerating] = useState(false);
    const { currentUser } = useApplicationContext();

    const toHumanReadableString = (date: Date): string => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-GB', { month: 'short' });
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };

    const handleDownload = async () => {
        setIsGenerating(true);
        try {
            const blob = await generateGuidedVisitDocx({
                activity,
                generatedBy: currentUser.searchLabel,
                intl,
            });

            saveAs(
                blob,
                `impact-${activity.facility?.label}-Visit-${activity.id}-${toHumanReadableString(new Date())}.docx`
            );
        } catch (error) {
            console.error('Failed to generate .docx', error);
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <DocumentButtonsStack.Action
            {...COMMON_DOCUMENT_BUTTONS.PRINT}
            onClick={handleDownload}
            disabled={formIsDirty || isGenerating}
            disablingReason={intl.formatMessage({
                id: 'document.form.disabledUnsaved',
            })}
        />
    );
};
